export default {"src":"/_next/static/media/diners.2a4cc1f0.svg","height":16,"width":68,"blurWidth":0,"blurHeight":0};